import * as yup from 'yup';

import './extensions';
import './translations';

export default yup;
